const URL = process.env.VUE_APP_API_URI;
export default URL;